import type { ReactNode } from 'react'

import { BillingInvoicesTable } from '@/components/billing/billing-invoices-table.organism'

import { useInvoicesSettings } from './use-invoices-settings.hook'

export const InvoicesSettingsView: React.FC = (): ReactNode => {
  const {
    invoiceList,
    pagination,
    isLoading,
    error,
    sortBy,
    sortOrder,
    filterValueList,
    handlePageChange,
    handlePageSizeChange,
    handleSortChange,
    handleFilterChange,
    handleDownload,
    handleRetry,
  } = useInvoicesSettings()

  if (error) {
    return (
      <div className="invoices-settings-view flex items-center justify-center p-8">
        <div className="text-center">
          <p className="text-destructive">{error}</p>
          <button
            type="button"
            className="mt-4 text-sm text-primary underline"
            onClick={handleRetry}
          >
            Try again
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="invoices-settings-view">
      <BillingInvoicesTable
        data={invoiceList}
        pagination={pagination}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        onDownload={handleDownload}
        sortBy={sortBy}
        sortOrder={sortOrder}
        onSortChange={handleSortChange}
        filterValueList={filterValueList}
        onFilterChange={handleFilterChange}
        isLoading={isLoading}
      />
    </div>
  )
}

InvoicesSettingsView.displayName = 'InvoicesSettingsView'
